import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// 公用CSS
import '@/assets/css/init.min.css';
// jquery
import $ from 'jquery';
// swiper
import swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
// echarts
// import echarts from 'echarts'
// element-UI
import Element from 'element-ui';
// element-UI-css
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import twLocale from 'element-ui/lib/locale/lang/zh-TW';
// element-UI-自定义主题
// import '@/assets/css/element-variables.scss'
// axios
import axios from 'axios';
// qs
import qs from 'qs';
// moment
import moment from 'moment';
// Decimal
import Decimal from 'decimal.js-light';
// 绑定原型
import bindPrototype from '@/assets/js/bindPrototype.js';
// mixinAjax
import mixinAjax from '@/assets/js/mixinAjax.js';
// 混入工具方法
import mixinTools from '@/assets/js/mixinTools.js';
// 混入业务逻辑方法
import mixinBusiness from '@/assets/js/mixinBusiness.js';
// 混入大数据
import mixinBigData from '@/assets/js/mixinBigData.js';
// 混入无埋点大数据
import mixinBuriedFreeStatistics from '@/assets/js/mixinBuriedFreeStatistics.js';
// 混入目的港航司检索框
import mixinDestAirlineSearch from '@/assets/js/mixinDestAirlineSearch.js';
// SJMLoading
import SJMLoading from '@/components/plugin/SJMLoading.vue';
// 站点面包屑导航
import SiteNav from '@/components/SiteNav';
// 暂无数据
import NoData from '@/components/plugin/NoData.vue';
// 二维码组件
import QrCode from '@/components/plugin/QrCode.vue';
// 商城公用组件
import SJMMall from '@/components/SJMMall.vue';
// i18n
import VueI18n from 'vue-i18n';
import en from '@/assets/json/i18n/en.json';
import zhCHS from '@/assets/json/i18n/zhCHS.json';
import zhCHT from '@/assets/json/i18n/zhCHT.json';
// Base64
import {Base64} from 'js-base64';
// html2canvas
import html2canvas from 'html2canvas';
// jspdf
import jspdf from 'jspdf';
// clipboard
import * as clipboard from 'clipboard-polyfill';
mixinTools.methods.$setLanguage('i18n');
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axios.defaults.headers['i18n'] = mixinTools.methods.$getCookie('i18n') || 'zhCHS';
axios.defaults.headers['currency'] = mixinTools.methods.$getCookie('currency') || 'CNY';
Vue.use(VueI18n);
// 获取当前语言
let i18nLocale = mixinTools.methods.$getCookie('i18n');
const i18n = new VueI18n({
    locale: !i18nLocale ? 'zhCHS' : i18nLocale,
    messages: {
        // 简体中文
        zhCHS: {
            message: zhCHS, ...zhLocale
        },
        // 繁体中文
        zhCHT: {
            message: zhCHT, ...twLocale
        },
        // 英文
        en: {
            message: en, ...enLocale
        }
    }
});

bindPrototype();
Vue.prototype.$ = $;
Vue.prototype.$swiper = swiper;
// Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$moment = moment;
Vue.prototype.$Decimal = Decimal;
Vue.prototype.$Base64 = Base64;
Vue.prototype.$html2canvas = html2canvas;
Vue.prototype.$jspdf = jspdf;
Vue.prototype.$clipboard = clipboard;
// Vue.prototype.$ysf = window['ysf'];// 网易七鱼客服
Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value),
    size: 'mini'
});
Vue.mixin(mixinAjax);
Vue.mixin(mixinTools);
Vue.mixin(mixinBusiness);
Vue.mixin(mixinBigData);
Vue.mixin(mixinBuriedFreeStatistics);
Vue.mixin(mixinDestAirlineSearch);
Vue.component('SJMLoading', SJMLoading);
Vue.component('SiteNav', SiteNav);
Vue.component('NoData', NoData);
Vue.component('QrCode', QrCode);
Vue.component('SJMMall', SJMMall);

Vue.config.productionTip = false;

// 复写$router.push方法
router.push = (location, onComplete, onAbort) => {
    router.history.push(location, onComplete, onAbort);
    let url = typeof location === 'string' ? location : location.path;
    // 如果是个人中心强制刷新内部组件
    if (String(url).indexOf('/personalCenter/PersonalCenterMain') === 0) {
        store.commit('routerPersonalCenterKey', String(Math.random()));
    }
};

// 复写$router.replace方法
router.replace = (location, onComplete, onAbort) => {
    router.history.replace(location, onComplete, onAbort);
    let url = typeof location === 'string' ? location : location.path;
    // 如果是个人中心强制刷新内部组件
    if (String(url).indexOf('/personalCenter/PersonalCenterMain') === 0) {
        store.commit('routerPersonalCenterKey', String(Math.random()));
    }
};

// 路由切换前
router.beforeEach((to, from, next) => {

    // 动态加载title
    const baseTitle = '三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询';
    if (to.meta.title !== undefined) {
        document.title = to.meta.title;
    } else {
        document.title = baseTitle;
    }

    // 判断是否是首页
    if (to.path === '/') {
        store.commit('isIndexPage', true);
    } else {
        store.commit('isIndexPage', false);
    }

    // 更新 大数据 记录路由切换的时间
    store.commit('bigDataFirstTime', +new Date());
    // 更新 大数据 记录上一次发送数据时间
    store.commit('bigDataStartTime', +new Date());

    next();
});

// 路由切换后
router.afterEach(() => {
    // 页面滚动位置回到顶部
    window.scrollTo(0, 0);
});

window.sjmVue = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

console.log(`%c
 ________        ___                 _____ ______   ________  ___       ___          
|\\_____  \\      |\\  \\               |\\   _ \\  _   \\|\\   __  \\|\\  \\     |\\  \\         
\\|____|\\ /_     \\ \\  \\  ____________\\ \\  \\\\\\__\\ \\  \\ \\  \\|\\  \\ \\  \\    \\ \\  \\        
      \\|\\  \\  __ \\ \\  \\|\\____________\\ \\  \\\\|__| \\  \\ \\   __  \\ \\  \\    \\ \\  \\       
     __\\_\\  \\|\\  \\\\_\\  \\|____________|\\ \\  \\    \\ \\  \\ \\  \\ \\  \\ \\  \\____\\ \\  \\____  
    |\\_______\\ \\________\\              \\ \\__\\    \\ \\__\\ \\__\\ \\__\\ \\_______\\ \\_______\\
    \\|_______|\\|________|               \\|__|     \\|__|\\|__|\\|__|\\|_______|\\|_______|
    
    
                                                                          %c 三脚猫电商
                                                                                                   %c 舱位真实有效 价格只跌不涨
                                                                                                   
                                                    %c 三脚猫电商(3j-mall.com)，招聘前端开发工程师(xak@job-mate.com)
                                                           
`,
    'color: #409EFF',
    'font-family:Microsoft Yahei;color: #409EFF;font-size:14px;',
    'font-family:Microsoft Yahei;color: #409EFF',
    'font-family:Microsoft Yahei;color: #bfbfbf',
);
